export const api = {
    getAnalyticsData: `/google-analytics-data`,
    getAnalyticsDataWithAuth: `/google-analytics-data`,
    checkAccess: `/check-admin-permissions`,
    amountOfUsers: `/statistics-all-users`,
}
